<label [class.disabled]="disabled">
    <ng-content></ng-content>
    <input type="checkbox"
        [ngModel]="checked" 
        (ngModelChange)="onModelChange($event)">
    <span class="check"
        [style.width.px]="checkSize"
        [style.height.px]="checkSize"
        [style.background-color]="checkBackgroundColor"
        [style.border]="checkBorderColor ? '1px solid ' + checkBorderColor : 'none'"
    >
        @if (checked) {
            <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6.46094L6.06168 10.5226" [style.stroke]="checkColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.0625 10.5218L13.7346 2.39844" [style.stroke]="checkColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>                
        }
    </span>
</label>
